/* PK side cart: opens on the page instead of going to /cart.
   - The buy box (after = "drawer") and the header cart icon open it.
   - Quantity changes keep the bundle price: the tier code that matches the new quantity is applied
     (tiers come from the page's buy box, kept in localStorage per product).
   - Free gifts follow the bundle: added when the main product reaches the gift minimum, removed below it
     (removal is also done by pk-cart-guard.js). */
(function () {
  if (window.PKCart) return;
  var cfgEl = document.getElementById('pk-cart-cfg');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { /* defaults */ }
  var T = Object.assign({ title: 'Your cart', checkout: 'Checkout', note: '', trust: '', empty: 'Your cart is empty.', cont: 'Continue shopping', icon: true, moneyFormat: '${{amount}}' }, cfg);
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var el, body, foot, countEl, lastFocus = null, busy = false, cart = null, lineQty = {};

  // ---------- money ----------
  // Visitors in CA/AU/NZ/UK see approximate local prices (rates from pk-footer); checkout charges the store currency.
  var FX = (function () { var L = window.pkLocal || {}, r = parseFloat(L.rate); return L.currency && r > 0 ? { sym: L.symbol || L.currency + ' ', rate: r } : null; })();
  function money(cents) {
    if (FX) {
      // Same ending as the USD price, rounded up: $29.99 -> CA$41.99, $59.98 -> CA$83.98; whole USD -> whole local.
      cents = Math.round(cents || 0);
      var v = cents * FX.rate / 100, e = cents % 100, x;
      if (!cents) x = 0; else if (!e) x = Math.round(v); else { x = Math.floor(v) + e / 100; if (x < v - 1e-9) x += 1; }
      return FX.sym + x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return storeMoney(cents);
  }
  function storeMoney(cents) {
    var f = T.moneyFormat || '${{amount}}';
    var v = (cents || 0) / 100;
    var two = v.toFixed(2), parts = two.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    }).replace(/<[^>]+>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }

  // ---------- tiers + gifts registered by the buy box ----------
  function store() { try { return JSON.parse(localStorage.getItem('pk_cart_rules') || '{}'); } catch (e) { return {}; } }
  function setRules(productId, rules) {
    try { var s = store(); s[productId] = rules; localStorage.setItem('pk_cart_rules', JSON.stringify(s)); } catch (e) { /* private mode */ }
  }

  // ---------- DOM ----------
  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'pk pk-cart';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="pk-cart__shade" data-pk-cart-close></div>' +
      '<aside class="pk-cart__panel" role="dialog" aria-modal="true" aria-labelledby="pk-cart-title">' +
        '<header class="pk-cart__head"><h2 id="pk-cart-title">' + esc(T.title) + ' <span class="pk-cart__count"></span></h2>' +
        '<button type="button" class="pk-cart__x" aria-label="Close" data-pk-cart-close>&times;</button></header>' +
        (T.note ? '<div class="pk-cart__note">' + esc(T.note) + '</div>' : '') +
        '<div class="pk-cart__body" aria-live="polite"></div>' +
        '<footer class="pk-cart__foot"></footer>' +
      '</aside>';
    document.body.appendChild(el);
    body = el.querySelector('.pk-cart__body');
    foot = el.querySelector('.pk-cart__foot');
    countEl = el.querySelector('.pk-cart__count');
    el.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hasAttribute('hidden')) close(); });
  }

  function lineHtml(it, i) {
    var p = it.properties || {};
    var gift = !!p._pk_gift;
    var props = Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k] !== '' && p[k] != null; })
      .map(function (k) { return '<span>' + esc(k) + ': ' + esc(p[k]) + '</span>'; }).join('');
    var variant = it.variant_title && !/default title/i.test(it.variant_title) ? '<span>' + esc(it.variant_title) + '</span>' : '';
    var price = gift
      ? '<s>' + money(it.original_line_price) + '</s><b class="pk-cart__free">FREE</b>'
      : (it.final_line_price < it.original_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '<b>' + money(it.final_line_price) + '</b>';
    var qty = gift
      ? '<span class="pk-cart__gifttag">Free gift</span>'
      : '<div class="pk-cart__qty"><button type="button" aria-label="One less" data-pk-d="-1" data-pk-key="' + esc(it.keys.join(',')) + '">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" aria-label="One more" data-pk-d="1" data-pk-key="' + esc(it.keys.join(',')) + '">+</button></div>';
    return '<div class="pk-cart__line' + (gift ? ' is-gift' : '') + '">' +
      (it.image ? '<a class="pk-cart__img" href="' + esc(it.url) + '"><img src="' + esc(img(it.image)) + '" alt="" loading="lazy" width="72" height="72"></a>' : '<span class="pk-cart__img"></span>') +
      '<div class="pk-cart__info"><a class="pk-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant || props ? '<div class="pk-cart__meta">' + variant + props + '</div>' : '') +
        '<div class="pk-cart__row">' + qty +
          (gift ? '' : '<button type="button" class="pk-cart__rm" data-pk-d="all" data-pk-key="' + esc(it.keys.join(',')) + '">Remove</button>') +
        '</div></div>' +
      '<div class="pk-cart__price">' + price + '</div></div>';
  }

  function render(c) {
    cart = c;
    countEl.textContent = c.item_count ? '(' + c.item_count + ')' : '';
    if (!c.item_count) {
      body.innerHTML = '<div class="pk-cart__empty"><p>' + esc(T.empty) + '</p><button type="button" class="pk-btn" data-pk-cart-close>' + esc(T.cont) + '</button></div>';
      foot.innerHTML = '';
      return;
    }
    // main products first, gifts after their product
    // Shopify can split one product into several lines when a bundle discount applies (e.g. 3 + 3): show them as one row
    var groups = {}, merged = [];
    c.items.forEach(function (it) {
      var k = it.variant_id + '|' + JSON.stringify(it.properties || {});
      var g = groups[k];
      if (!g) { g = groups[k] = Object.assign({}, it, { keys: [], quantity: 0, original_line_price: 0, final_line_price: 0, lines: [] }); merged.push(g); }
      g.keys.push(it.key); g.lines.push({ key: it.key, q: it.quantity });
      g.quantity += it.quantity; g.original_line_price += it.original_line_price; g.final_line_price += it.final_line_price;
    });
    var items = merged.sort(function (a, b) { return (!!(a.properties || {})._pk_gift) - (!!(b.properties || {})._pk_gift); });
    lineQty = {}; merged.forEach(function (g) { g.lines.forEach(function (l) { lineQty[l.key] = l.q; }); });
    body.innerHTML = items.map(lineHtml).join('');
    var disc = (c.cart_level_discount_applications || []).map(function (d) {
      return '<div class="pk-cart__sum pk-cart__disc"><span>' + esc(T.discount || 'Bundle discount') + (d.title ? ' <small>(' + esc(d.title) + ')</small>' : '') + '</span><span>&minus;' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');
    var saved = Math.max(0, (c.original_total_price || 0) - (c.total_price || 0));
    foot.innerHTML =
      disc +
      '<div class="pk-cart__sum pk-cart__total"><span>Total' + (saved > 0 ? ' <em class="pk-cart__saved">You save ' + money(saved) + '</em>' : '') + '</span><span>' + money(c.total_price) + '</span></div>' +
      '<a class="pk-btn pk-cart__go" href="/checkout">' + esc(T.checkout) + ' &middot; ' + money(c.total_price) + '</a>' +
      (FX ? '<div class="pk-cart__fx">Approximate. Charged in ' + esc(T.base || 'USD') + ' at checkout: ' + storeMoney(c.total_price) + '</div>' : '') +
      (T.trust ? '<div class="pk-cart__trust">' + esc(T.trust) + '</div>' : '') +
      (T.payments ? '<div class="pk-cart__pay">' + T.payments + '</div>' : '');
  }

  function load() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { build(); return load().then(function (c) { render(c); bubble(); return c; }); }

  // Dawn header cart count
  function bubble() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['cart-icon-bubble']; if (!html) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var inner = d.querySelector('.shopify-section');
      if (inner) b.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  // After a quantity change: apply the tier code that fits the new quantity, add or keep free gifts.
  function fixOffer(c) {
    var rules = store(), jobs = [];
    var mainQty = {};
    c.items.forEach(function (it) { if (!(it.properties || {})._pk_gift) mainQty[it.product_id] = (mainQty[it.product_id] || 0) + it.quantity; });
    var codeWanted = null;
    Object.keys(mainQty).forEach(function (pid) {
      var r = rules[pid]; if (!r) return;
      var best = null;
      (r.tiers || []).forEach(function (t) { if (t.qty <= mainQty[pid] && (!best || t.qty > best.qty)) best = t; });
      if (best) codeWanted = best.code || '';
      if (r.gifts && r.gifts.length && mainQty[pid] >= (r.giftsMin || 1)) {
        var have = {};
        c.items.forEach(function (it) { if ((it.properties || {})._pk_gift) have[it.variant_id] = true; });
        var add = r.gifts.filter(function (v) { return !have[v]; }).map(function (v) { return { id: +v, quantity: 1, properties: { _pk_gift: String(pid), _pk_min: String(r.giftsMin || 1) } }; });
        if (add.length) jobs.push(function () { return fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: add }) }); });
      }
    });
    var current = (c.discount_codes || []).map(function (d) { return d.code; })[0] || '';
    if (codeWanted !== null && codeWanted.toUpperCase() !== current.toUpperCase()) {
      jobs.push(function () { return fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ discount: codeWanted }) }); });
    }
    return jobs.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve());
  }

  // keys: the cart lines of one row; d: +1, -1 or 'all' (remove the row)
  function change(keys, d) {
    if (busy) return;
    var upd = {};
    if (d === 'all') keys.forEach(function (k) { upd[k] = 0; });
    else { var k = keys[keys.length - 1]; upd[k] = Math.max(0, (lineQty[k] || 0) + d); }
    busy = true; el.classList.add('is-busy');
    fetch('/cart/update.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { return fixOffer(c); })
      .then(function () { return new Promise(function (res) { setTimeout(res, 250); }); }) // let the gift guard run
      .then(refresh)
      .catch(function () { return refresh(); })
      .then(function () { busy = false; el.classList.remove('is-busy'); });
  }

  function onClick(e) {
    var q = e.target.closest('[data-pk-d]');
    if (q) { var d = q.getAttribute('data-pk-d'); e.preventDefault(); change(q.getAttribute('data-pk-key').split(','), d === 'all' ? 'all' : +d); return; }
    if (e.target.closest('[data-pk-cart-close]')) { e.preventDefault(); close(); }
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    document.body.appendChild(el); // last in the page, so nothing added later (chat widgets, Shopify's preview bar) sits on top
    el.removeAttribute('hidden');
    fit();
    // if something still covers the bottom edge (Shopify's theme-preview bar), keep the checkout button and icons above it
    var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'), pad = 0;
    if (pb && pb.offsetHeight) {
      var hit = document.elementFromPoint(window.innerWidth - 20, window.innerHeight - 8);
      if (hit && (hit === pb || pb.contains(hit))) pad = Math.max(0, window.innerHeight - pb.getBoundingClientRect().top);
    }
    el.style.setProperty('--pk-cart-pb', pad + 'px');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    // phones: lock the page behind; desktop: the page behind keeps scrolling
    if (window.matchMedia('(max-width: 749px)').matches) document.documentElement.classList.add('pk-cart-lock');
    body.innerHTML = cart ? body.innerHTML : '<div class="pk-cart__loading">Loading…</div>';
    refresh().then(function () { var x = el.querySelector('.pk-cart__x'); if (x) x.focus(); });
  }
  // The panel takes the height of what is visible right now (phones hide and show their toolbars; 100vh can run under them)
  function fit() { if (el) el.style.height = window.innerHeight + 'px'; }
  window.addEventListener('resize', function () { if (el && !el.hasAttribute('hidden')) fit(); });
  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('pk-cart-lock');
    setTimeout(function () { el.setAttribute('hidden', ''); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // header cart icon opens the drawer
  if (T.icon) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('#cart-icon-bubble, a.header__icon--cart, a[href="/cart"].pk-cart-link');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault(); open();
    }, true);
  }
  document.addEventListener('pk:cart-open', open);
  document.addEventListener('pk:cart-guarded', function () { if (el && !el.hasAttribute('hidden')) refresh(); });

  window.PKCart = { open: open, close: close, refresh: refresh, setRules: setRules };
})();
